import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import useAddFundsOut from '@hooks/useAddFundsOut';
import FormBankAccount from '@components/Forms/FormBankAccount';
import { FormBankAccountPe, FormBankAccountCo } from '@components';
import { isCountryPeru, isCountryChile } from '@constants/regions';
import { saparateDocSelected } from '@constants/bankAccountType';

const EditBankAccount = () => {
  const { merchant } = useSelector((state) => state.login);
  const { accountTypes, bankNames } = useAddFundsOut(); // TODO: analizar si se remueve para peru
  const [formDocs, setFormDocs] = useState([]);

  useEffect(() => {
    const docs = [];

    if (isCountryChile) {
      docs.push({
        value: merchant.document.doc_number,
        text: merchant.document.doc_number,
      });
    } else
      docs.push({
        value: `${merchant.document.doc_type}${saparateDocSelected}${merchant.document.doc_number}`,
        text: `${merchant.document.doc_type}${saparateDocSelected}${merchant.document.doc_number}`,
      });

    if (merchant.legal_agent.document.doc_number !== merchant.document.doc_number) {
      if (isCountryChile) {
        docs.push({
          value: merchant.legal_agent.document.doc_number,
          text: merchant.legal_agent.document.doc_number,
        });
      } else {
        docs.push({
          value: `${merchant.legal_agent.document.doc_type}${saparateDocSelected}${merchant.legal_agent.document.doc_number}`,
          text: `${merchant.legal_agent.document.doc_type}${saparateDocSelected}${merchant.legal_agent.document.doc_number}`,
        });
      }
    }
    setFormDocs(docs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchant]);

  return (
    <>
      {isCountryChile ? (
        <FormBankAccount edit ruts={formDocs} accountTypes={accountTypes} bankNames={bankNames} />
      ) : isCountryPeru ? (
        <FormBankAccountPe edit docs={formDocs} />
      ) : (
        <FormBankAccountCo edit docs={formDocs} />
      )}
    </>
  );
};

export default EditBankAccount;
